/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  DeleteManyCertificateRequestsMutationRequest,
  DeleteManyCertificateRequestsMutationResponse,
} from "../types/DeleteManyCertificateRequests.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const deleteManyCertificateRequestsMutationKey = () =>
  [{ url: "/v1/certificate-request/delete-many-certificate-requests" }] as const

export type DeleteManyCertificateRequestsMutationKey = ReturnType<
  typeof deleteManyCertificateRequestsMutationKey
>

/**
 * @summary Delete many certificate requests
 * {@link /v1/certificate-request/delete-many-certificate-requests}
 */
export async function deleteManyCertificateRequests(
  data: DeleteManyCertificateRequestsMutationRequest,
  config: Partial<
    RequestConfig<DeleteManyCertificateRequestsMutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    DeleteManyCertificateRequestsMutationResponse,
    ResponseErrorConfig<Error>,
    DeleteManyCertificateRequestsMutationRequest
  >({
    method: "DELETE",
    url: `/v1/certificate-request/delete-many-certificate-requests`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function deleteManyCertificateRequestsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<DeleteManyCertificateRequestsMutationRequest>
  > & { client?: Client } = {}
) {
  const mutationKey = deleteManyCertificateRequestsMutationKey()
  return mutationOptions<
    ResponseConfig<DeleteManyCertificateRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteManyCertificateRequestsMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return deleteManyCertificateRequests(data, config)
    },
  })
}

/**
 * @summary Delete many certificate requests
 * {@link /v1/certificate-request/delete-many-certificate-requests}
 */
export function useDeleteManyCertificateRequests<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteManyCertificateRequestsMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: DeleteManyCertificateRequestsMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<DeleteManyCertificateRequestsMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? deleteManyCertificateRequestsMutationKey()

  const baseOptions = deleteManyCertificateRequestsMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<DeleteManyCertificateRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteManyCertificateRequestsMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<DeleteManyCertificateRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteManyCertificateRequestsMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeleteManyCertificateRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteManyCertificateRequestsMutationRequest },
    TContext
  >
}
